<template>
	<div class="xiangmu">
		<div class="leaderBox" v-if="showOrhideCopy">
			<div class="newtext">新手指引</div>
			<img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeItCopy">
			<img src="../../../assets/images/pop/xmlb/xmlb.jpg" class="steps step5" v-if="statusCopy==5">
			<div class="stepbtn" @click="nextStepCopy(statusCopy)">
				{{statusCopy==5?"我知道了":"我知道了"}}
			</div>
			<div class="bottomTip">
				<el-checkbox v-model="checkedCopy">下次不再提示</el-checkbox>
			</div>
		</div>
<!--		<div class="h-crumbOut">-->
<!--			<div class="h-crumbs">-->
<!--				<el-breadcrumb separator="|">-->
<!--					<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
<!--					<el-breadcrumb-item>-->
<!--						<a href="/xiangmu/pm">项目列表</a>-->
<!--					</el-breadcrumb-item>-->
<!--				</el-breadcrumb>-->
<!--			</div>-->
<!--		</div>-->
    <Breadtabsheader/>
		<div class="h-piece h-mrt30" style="margin:20px">
			<div class="h-formBox">
				<el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
					<div class="h-thirdColumn w-newColumn">
						<el-form-item label="项目类别">
							<brselect style="width: 100%;" category="pro_type" :v="q.type" v-model="q.type" clearable></brselect>
						</el-form-item>
						<el-form-item label="区域">
							<brselect style="width: 100%;" category="pro_area" :v="q.area" v-model="q.area" clearable></brselect>
						</el-form-item>
						<el-form-item label="项目名称">
							<el-input v-model="q.projectNameLike" placeholder="请输入项目名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="项目编码">
							<el-input v-model="q.idLike" placeholder="请输入项目编码" clearable></el-input>
						</el-form-item>
					</div>
					<el-collapse-transition>
						<div v-show="isScreen">
							<div class="h-thirdColumn w-newColumn">
								<el-form-item label="客户名称">
									<el-input v-model="q.customerNameLike" placeholder="请输入名称" clearable></el-input>
								</el-form-item>
                				<el-form-item label="是否上传合同" prop="isClose" v-if="xmgly || adminFlag">
                				    <el-select v-model="q.isClose" :clearable="true"
                				               placeholder="请选择">
                				        <el-option label="已上传" value="1"></el-option>
                				        <el-option label="未上传" value="0"></el-option>
                				    </el-select>
                				</el-form-item>
								<el-form-item label="审核状态" prop="isClose">
									<el-select v-model="q.status" :clearable="true"
											   placeholder="请选择">
										<el-option label="草稿" value="0"></el-option>
										<el-option label="提交审核" value="1"></el-option>
										<el-option label="审核通过" value="2"></el-option>
										<el-option label="驳回" value="3"></el-option>
									</el-select>
								</el-form-item>
							</div>
						</div>
					</el-collapse-transition>
				</el-form>
				<div class="l-screenBox">
					<div class="l-screen" @click="collapseChange">
						<img :src="isScreen?closeScreen:drawScreen" alt="">
						<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
					</div>
					<div class="l-retrieval">
						<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
						<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
						<el-button v-auth="'newProject'" icon="el-icon-plus" class="h-btn h-formBtn h-bggreen" @click="createdemand">新建项目
						</el-button>
					</div>
				</div>
			</div>
		</div>
		<div class="h-table h-mrt30" style="margin:20px">
			<el-table ref="multipleTable" @selection-change="handleSelectionChange" :data="tableData" :span-method="objectSpanMethod"
			 stripe style="width: 100%"  :border="true" :row-style="cellstyle" max-height="460">
				<el-table-column type="selection" width="50" :label="all" fixed></el-table-column>
				<el-table-column type="index" label="#" width="40" fixed></el-table-column>
				<el-table-column prop="projectName" label="项目名称" min-width="180" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<div style="text-align: left;">
							{{scope.row.projectName}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="id" label="项目编码" min-width="160" :show-overflow-tooltip="true"></el-table-column>
				<el-table-column prop="customerName" label="客户名称" min-width="180" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<div style="text-align: left;">
							{{scope.row.customerName}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="type" label="类型" min-width="70" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<dictname category="pro_type" :v="scope.row.type" />
					</template>
				</el-table-column>
<!--				<el-table-column prop="isConvert" min-width="90" label="是否转化">-->
<!--					<template slot-scope="scope" v-if="scope.row.type!=5">-->
<!--						<dictname category="pro_convert" :v="scope.row.isConvert" />-->
<!--					</template>-->
<!--				</el-table-column>-->
				<el-table-column prop="tjyl" min-width="90" label="特价余量">
					<template slot-scope="scope" v-if="scope.row.type!=5">
						<div style="text-align: right;">
							{{scope.row.tjyl}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="isSuccess" min-width="90" label="是否中标">
					<template slot-scope="scope" v-if="scope.row.type==3">
						<dictname category="pro_success" :v="scope.row.isSuccess" />
					</template>
				</el-table-column>
				<el-table-column prop="isClose" min-width="120" label="是否上传合同" v-if="xmgly || adminFlag">
					<template slot-scope="scope" v-if="scope.row.type==3">
						<dictname category="shifou_keyong" :v="scope.row.isClose" />
					</template>
				</el-table-column>
				<el-table-column prop="status" min-width="90" label="审核状态">
					<template scope="scope">
						<span v-if="scope.row.status == '0'">草稿</span>
						<span v-if="scope.row.status == '1'">提交审核</span>
						<span v-if="scope.row.status == '2'">审核通过</span>
						<span v-if="scope.row.status == '3'">驳回</span>
					</template>
				</el-table-column>
				<!--<el-table-column prop="cucode" label="创建人工号" width="140" :show-overflow-tooltip="true">-->
				<!--</el-table-column>-->
				<el-table-column prop="cuname" label="创建人" min-width="150" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						{{scope.row.cuname+"["+scope.row.cucode+"]"}}
					</template>
				</el-table-column>

				<el-table-column
						prop="cdate"
						label="创建时间"
						:formatter="formatDate"
						width="110">
				</el-table-column>

				<el-table-column prop="productName" label="产品" min-width="150" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<div style="text-align: left;">
							{{scope.row.productName}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="oemDesc" label="规格型号" min-width="150" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<div style="text-align: left;">
							{{scope.row.oemDesc}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="productPrice" label="基准价" min-width="80" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<div style="text-align: right;">
							{{scope.row.type != '5' ?scope.row.productPrice:'-'}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="tejiaPrice" label="项目价" min-width="80" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<div style="text-align: right;">
							{{scope.row.type != '5' ?scope.row.tejiaPrice:'-'}}
						</div>
					</template>
				</el-table-column>

				<el-table-column prop="finalSupplierName" label="确定供应商" min-width="110" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						{{scope.row.type == '5' ?scope.row.finalSupplierName:'-'}}
					</template>
				</el-table-column>
				<!--<el-table-column prop="inquiryTime" label="报价时间" min-width="220" :show-overflow-tooltip="true">-->
				<!--</el-table-column>-->
				<el-table-column prop="supplierPrice" label="采购价" min-width="80" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<div style="text-align: right;">
							{{scope.row.type == '5' ?scope.row.supplierPrice:'-'}}
						</div>
					</template>
				</el-table-column>


				<el-table-column label="操作" width="400" fixed="right">
					<template slot-scope="scope">
						<div style="display: flex;justify-content: flex-start;align-items: left;">
							<!-- <div class="l-operationBox"> -->
								<router-link :to="{path:'/xiangmu/Pdetails', query: {id: scope.row.id,protype:scope.row.type,keepAlive:true}}">
									<el-button type="text" size="small" class="h-tableLink h-btn" style="">查看</el-button>
									<!-- <span class="l-operationlist br-operation-look" title="查看"></span> -->
								</router-link>
							<!-- </div> -->


							<div :key="Math.random()" v-if="scope.row.type==1">
								<!-- <div class="l-operationBox"> -->
									<router-link v-show="scope.row.status==3" v-auth="'xgzhanhuibohui'" :to="{path:'/xiangmu/newProject', query: {id: scope.row.id,type:'xm',protype:scope.row.type}}">
										<el-button type="text" size="small" class="h-tableLink h-btn">修改</el-button>
										<!-- <span class="l-operationlist br-operation-xg" title="修改"></span> -->
									</router-link>
									<router-link v-show="scope.row.status==2" v-auth="'zhanhuiwhkh'" :to="{path:'/xiangmu/Pdetails', query: {id: scope.row.id,type:'xm',protype:scope.row.type,whflag:1}}">
										<el-button type="text" size="small" class="h-tableLink h-btn">维护客户</el-button>
										<!-- <span class="l-operationlist br-operation-whkh" title="维护客户"></span> -->
									</router-link>
									<el-button  size="small"
												class="h-tableLink h-btn" @click="tejiashenpigenzong(scope.row)" v-if="scope.row.tid!=null">
										特价跟踪
									</el-button>

									<el-button v-show="scope.row.type==5||scope.row.type==1" size="small"
											   class="h-tableLink h-btn" @click="genzongLiuch(scope.row)">
										跟踪
									</el-button>
									<!-- <span class="l-operationlist br-operation-spgz" v-if="scope.row.tid!=null" title="特价审批跟踪" @click="tejiashenpigenzong(scope.row)"></span>
									<span class="l-operationlist br-operation-spgz" v-show="scope.row.type==5||scope.row.type==1" title="跟踪审批" @click="genzongLiuch(scope.row)"></span> -->
								<!-- </div> -->
							</div>
							<div :key="Math.random()" v-if="scope.row.type==2">
								<!-- <div class="l-operationBox"> -->
									<router-link  v-auth="'xgwaixiao'" :to="{path:'/xiangmu/newProject', query: {id: scope.row.id,type:'xm',protype:scope.row.type}}">
										<el-button type="text" size="small" class="h-tableLink h-btn">修改</el-button>
										<!-- <span class="l-operationlist br-operation-xg" title="修改"></span> -->
									</router-link>
									<el-button  size="small"
												class="h-tableLink h-btn" @click="tejiashenpigenzong(scope.row)" v-if="scope.row.tid!=null">
										特价跟踪
									</el-button>

									<el-button v-show="scope.row.type==5||scope.row.type==1" size="small"
											   class="h-tableLink h-btn" @click="genzongLiuch(scope.row)">
										跟踪
									</el-button>
									<!-- <span class="l-operationlist br-operation-spgz" v-if="scope.row.tid!=null" title="特价审批跟踪" @click="tejiashenpigenzong(scope.row)"></span>
									<span class="l-operationlist br-operation-spgz" v-show="scope.row.type==5||scope.row.type==1" title="跟踪审批" @click="genzongLiuch(scope.row)"></span> -->
								<!-- </div>	 -->
							</div>
							<div :key="Math.random()" v-if="scope.row.type==3">
								<!-- <div class="l-operationBox"> -->
									<router-link target="_blank" v-show="scope.row.isSuccess==2" v-auth="'xgzhongbiao'"  :to="{path:'/xiangmu/newProject', query: {id: scope.row.id,type:'bid',protype:scope.row.type}}">
										<el-button type="text" size="small" class="h-tableLink h-btn">修改中标</el-button>
										<!-- <span class="l-operationlist br-operation-xg" title="修改"></span> -->
									</router-link>
								<router-link v-show="scope.row.isClose=='0'" :to="{path:'/xiangmu/nxedit', query: {id: scope.row.id}}">
									<el-button type="text" size="small" class="h-tableLink h-btn">修改</el-button>
									<!-- <span class="l-operationlist br-operation-xg" title="修改"></span> -->
								</router-link>
									<el-button  size="small"
												class="h-tableLink h-btn" @click="tejiashenpigenzong(scope.row)" v-if="scope.row.tid!=null">
										特价跟踪
									</el-button>

									<el-button v-show="scope.row.type==3||scope.row.type==1" size="small"
											   class="h-tableLink h-btn" @click="genzongLiuch(scope.row)">
										跟踪
									</el-button>
									<!-- <span class="l-operationlist br-operation-spgz" v-if="scope.row.tid!=null" title="特价审批跟踪" @click="tejiashenpigenzong(scope.row)"></span>
									<span class="l-operationlist br-operation-spgz" v-show="scope.row.type==3||scope.row.type==1" title="跟踪审批" @click="genzongLiuch(scope.row)"></span> -->
								<!-- </div> -->
							</div>
							<div :key="Math.random()" v-if="scope.row.type==5 && scope.row.status==2  && (_user.usercode == scope.row.cucode || adminFlag) && scope.row.showXj">
								<!-- <div class="l-operationBox"> -->
									<router-link v-auth="'caigouxunjia'" :to="{path:'/xiangmu/xmxunjbaojzdgys', query: {id: scope.row.id,type:'xm',protype:scope.row.type}}">
										<el-button type="text" size="small" class="h-tableLink h-btn">维护询报价</el-button>
										<!-- <span class="l-operationlist br-operation-whxbj" title="维护询报价"></span> -->
									</router-link>
								<!-- </div> -->
							</div>
							<el-button :key="Math.random()" v-show="scope.row.type==5 && scope.row.instid" size="small"
									   class="h-tableLink h-btn" @click="genzongLiuch(scope.row)">
								跟踪
							</el-button>
							<el-button type="text" size="small" class="h-tableLink h-btn"
									   @click="yinglicesuan(scope.row)"
									   v-show="scope.row.type==3||scope.row.type==2||scope.row.type==4"
									   v-auth="'yinglicesuan'"
                     v-if="scope.row.status == '2'"
							>盈利测算</el-button>

							<el-button @click="deleteRow(scope.row)" :key="Math.random()" v-if="scope.row.type==5 && scope.row.xunjiaFlag==0 && (_user.usercode == scope.row.cucode || adminFlag)" size="small" class="h-tableLink h-btn" >
								删除
							</el-button>
							<el-button @click="deleteRow(scope.row)" :key="Math.random()" v-if="scope.row.type!=5 && scope.row.status != 2 && (_user.usercode == scope.row.cucode || adminFlag)" size="small" class="h-tableLink h-btn" >
								删除
							</el-button>
							<!-- <div class="l-operationBox">
								<span class="l-operationlist br-operation-ylcs" v-show="scope.row.type==3||scope.row.type==2||scope.row.type==4" v-auth="'yinglicesuan'" title="盈利测算" @click="yinglicesuan(scope.row)"></span>
								<span class="l-operationlist br-operation-delete" title="删除" @click="deleteRow(scope.row)"></span>
							</div> -->
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="h-tableB h-mrt30">
				<div class="h-tableBL" style="margin-left:20px">
					<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" style="margin-left:-20px;" @click="exportExcel">
						批量导出
					</el-button>
					<!-- <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import">批量导入</el-button> -->
				</div>
				<div class="h-pagination2">
					<pagination :page="q" @query="query" />
				</div>
			</div>
		</div>
		<!-- <el-dialog :visible.sync="dialogFormVisible1" class="h-dialog2">
			<div class="leaderBox" v-if="showOrhide3">
				<img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt3">
				<img src="../../../assets/images/xjxm1.png" class="steps step11" v-if="status3==11">
				<img src="../../../assets/images/xjxm2.png" class="steps step12" v-if="status3==12">
				<div class="stepbtn" @click="nextStep3(status3)">
					{{status3==11?"下一步":status3==12?"我知道了":"我知道了"}}
				</div>
				<div class="bottomTip">
					<el-checkbox v-model="checked3">下次不再提示</el-checkbox>
				</div>
			</div>
			<div class="h-dialogImg">
				<div class="h-disTable">
					<div class="h-tableCell">
						<h1>选择项目类型</h1>
						<p>Choose Style</p>
					</div>
				</div>
			</div>
			<div class="h-formLines" style="padding:30px 48px;">
				<div class="xuqiuBoxList">
					<div class="xuqiulist" :class="{'active':xuqiudex==index}" v-for="(item,index) in xuqiuList" v-auth="'xiangmu'+index"
					 :key="index" @click="xuqiuGo(index)">
						<p>{{item}}</p>
						<img v-if="xuqiudex==index" src="../../../assets/images/checkBox.png" style="margin-left:20px;" />
					</div>
				</div>
				<div class="xuqiutext" style="margin-top:30px;"><span style="color:#f46071">*</span>资源需求是指用户在使用海尔生物医疗产品中遇到了问题需要海尔生物医疗内部人员资源协助。由销售人员发起，对应的协助人员进行问题闭环处理。
				</div>
				<div class="xuqiutext"><span style="color:#f46071">*</span>信息获取是指销售人员在与客户沟通过程中收集到的产品购买意向，保留产品信息和预计购买金额。
				</div>
				<div class="xuqiutext"><span style="color:#f46071">*</span>采购项目是指用户有意向购买的产品属于海尔非自产产品，销售人员需要向采购部分人员发起采购产品需求。
				</div>
				<div style="display:flex;justify-content:center">
					<el-button class="h-btn h-formBtn" type="primary" @click="gotonewProject()">确定</el-button>
				</div>
			</div>
		</el-dialog> -->
		<!-- 选择项目类型弹窗 -->
		<projectadd :visible.sync="imgfalse4" v-if="imgfalse4" @imgfalse4="imgfalse4=false" />

		<viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid" />

		<viewhistory :visible.sync="tejiaxianshi" v-if="tejiaxianshi" :id="tid" />
	</div>
</template>
<script>
	import ss from "../../../api/SystemService";
	import updownfile from '../../../utils/updownfile'
	export default {
		data() {
			return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
				tid:null,
				tejiaxianshi:false,
				spanArr: [],
				// 账号00614201
				showOrhideCopy: false,
				statusCopy: 5,
				checkedCopy: true,
				toshowCopy: 'pmCopy1',
				imgfalse4:false,
				isClose:0,

				//表单
				all: "全部",
				q: {
					pageSize: 10,
					pageNo: 1,
					total: 0,
					isClose:0,
					status:null,
					type:null,
					area:null,
					projectNameLike:null,
					idLike:null,
					customerNameLike:null,
					isClose:null,
				},
				adminFlag:false,
				xmgly:false,
				//表格
				multipleSelection: [],
				showhistory: false,
				instid: null,
				tableData: [],
				dialogFormVisible1: false,
				xuqiudex: 4,
				xuqiuList: ['内销项目', '外销项目', '采购项目', '展会项目'],
			};

		},
		created() {
			this.adminFlag = this.$store.getters.hasRole('swyl_admin');
			this.showzhezhao();
			//内销项目管理员
            this.xmgly = this.$store.getters.hasRole('swyl_xiangmgly');
		},
        beforeRouteLeave(to,from,next){
            from.meta.keepAlive = to.query.keepAlive||false;
            to.query.keepAlive = false;
            next()
        },
		methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
			cellstyle(value){
				//console.log(value)
				if(value.row.isClose == '0' && value.row.type == '3'){
					return 'color: #F56C6C;'
				}
			},

			tejiashenpigenzong(q){

				this.tid = q.tid;
				this.tejiaxianshi = true;

			},

			deleteRow(v) {
				this.$msg.confirm("确认删除?", () => {
					ss.ProService.deleteById(v.id).then(rd => {
						this.query();
						this.$store.dispatch('searchTasktotal');
					});
				})
			},

			showzhezhao(){
				ss.salesList.toshow(this.toshowCopy).then(rd => {
					console.log(rd)
				    if(rd == false){
				        this.showOrhideCopy = false;
				    }else{
				        this.showOrhideCopy = true;
				    }
				})
			},
			getSpanArr() {
				this.spanArr = [];
				this.tableData.forEach((item, index) => {
					if (index === 0) {
						this.spanArr.push(1);
						this.position = 0;
					} else {
						if (this.tableData[index].id === this.tableData[index - 1].id) {
							this.spanArr[this.position] += 1;
							this.spanArr.push(0);
						} else {
							this.spanArr.push(1);
							this.position = index;
						}
					}
				})
			},
			objectSpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {

				if (
				    _.includes(["项目名称","项目编码","客户名称","类型","是否转化","特价余量","是否闭环","是否上传合同","是否中标","创建人","创建时间","操作"],column.label)
				) {
					const _row = this.spanArr[rowIndex];
					const _col = _row > 0 ? 1 : 0;
					return {
						rowspan: _row,
						colspan: _col
					}
				}
			},
			closeItCopy() {
				this.showOrhideCopy = false;
				if (this.checkedCopy) {
					ss.salesList.toshow(this.toshowCopy,this.checkedCopy).then(rd => {
						console.log(rd)
						this.showOrhideCopy = false;
					})
				}else{
					ss.salesList.toshow(this.toshowCopy,this.checkedCopy).then(rd => {
						console.log(rd)
						this.showOrhideCopy = false;
					})
				}
			},
			nextStepCopy(i) {
				if (this.statusCopy == 5) {
					ss.salesList.toshow(this.toshowCopy,this.checkedCopy).then(rd => {
						console.log(rd)
						this.showOrhideCopy = false;
					})
				} else {
					ss.salesList.toshow(this.toshowCopy,this.checkedCopy).then(rd => {
						console.log(rd)
						this.showOrhideCopy = false;
					})
				}
			},



			//盈利测算跳转
			yinglicesuan(q) {

				//内外销测算跳转判断
				this.neiwaixiaopanduan(q)

			},



			//内外销测算跳转判断
			neiwaixiaopanduan(q){
				var url;
				if (q.type == '2') { //外销
					//跳转外销测算
					url = this.$router.resolve({
						path: '/xiangmu/entersix',
						query: {
							id: q.id,
							protype: q.type,
							projectName: q.projectName
						}
					});
				} else if (q.type == '3') { //内销
					//跳转内销测算
					url = this.$router.resolve({
						path: '/xiangmu/enterthree',
						query: {
							id: q.id,
							protype: q.type,
							projectName: q.projectName
						}
					});
				}
				window.open(url.href, "_blank");

			},




			//表格
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 重置按钮
			resetData() {
				this.q.customerNameLike = null;
				this.q.isClose = null;
				this.q.projectNameLike = null;
				this.q.idLike = null;
				this.q.area = null;
				this.q.type = null;
				this.q.status = null;
			},
			query(p) {
				this.q.ids = null;
				ss.ProService.page(this.q).then(rd => {
					console.log(rd, "项目列表");
					console.log('我在这儿呀112', this._user.roles);
					this.q.total = rd.total;
					this.tableData = rd.records;
					console.log(rd, "================");
					this.getSpanArr();
				});

			},
			genzongLiuch(r) {
				console.log("instid", r);
				this.instid = r.instid;
				this.showhistory = true;
			},
			handleFilter() {
				this.query();
			},
			//明细导出
			exportExcel() {
				var idlist = [];
				this.multipleSelection.forEach(element => {
					idlist.push(element.id);
				});
				this.q.ids = idlist
				console.log("aaaaa", this.q.ids);
				updownfile.down("/api/swyl/v1/xiangmu/proMain/getExcel", this.q, "post", 'data');
			},
			//新建项目
			createdemand() {
				this.imgfalse4 = true
				// this.dialogFormVisible1 = true;
			},
			xuqiuGo(index) {
				this.xuqiudex = index;
			},
			//日期格式化
			formatDate(row, column) {
				// 获取单元格数据
				let data = row[column.property]
				if(data == null || data == '') {
					return null
				}
				let dt = new Date(data)
				return this.$util.riQi3(dt);
			},

		},
		mounted() {
			this.query();
		}
	};
</script>
<style scoped>
	.xuqiuBoxList {
		width: 100%;
		margin-top: 30px;
		display: flex;
		justify-content: space-between;
	}

	.xuqiuBoxList .xuqiulist {
		width: 200px;
		height: 62px;
		border-radius: 4px;
		background: #fff;
		border: 1px solid #959595;
		text-align: center;
		line-height: 62px;
		color: #989898;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-left: 10px;
	}

	.xuqiuBoxList .xuqiulist:first-child {
		margin-left: 0
	}

	.xuqiuBoxList .xuqiulist.active {
		background: #238cfd;
		border: 1px solid #238cfd;
		color: #fff;
	}

	.xuqiutext {
		color: #bcbcbc;
		font-size: 14px;
		margin-bottom: 14px;
	}
</style>
<style scoped lang="scss">
	.bottomTip {
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
		z-index: 999999;
	}

	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}

	.leaderBox {
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;

		.leaderbg {
			width: 100%;
			height: 100%;

		}

		.steps {
			position: absolute;
			z-index: 1;
		}

		.step5 {
			top: 0;
			left: 0;
		}

		.stepbtn {
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0, 0, 0, 0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.75rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}

		.closeIt {
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
			z-index: 2;
		}
	}
</style>
